import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UserProgram } from 'models/programs.types';

import { RootState } from 'store';
import { ProgramsState } from './programs.types';

const initialState: Readonly<ProgramsState> = {
  programs: []
} as const;

const programsSlice = createSlice({
  initialState,
  name: 'programs',
  reducers: {
    clearPrograms: () => initialState,
    setPrograms: (state, action: PayloadAction<UserProgram[]>) => {
      action.payload.forEach((program) => {
        const index = state.programs.findIndex((p) => p.program._id === program.program._id);
        if (index !== -1) {
          state.programs[index] = program;
        } else {
          state.programs.push(program);
        }
      });
    }
  }
});

export const { clearPrograms, setPrograms } = programsSlice.actions;

export const selectPrograms = (state: RootState) => state.programs ?? initialState;

export default programsSlice.reducer;
